import { ComponentPropsWithoutRef } from 'react';

export default function BoldCross(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      {...props}
      version="1.1"
      viewBox="0 0 9 9"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="2"
        d="m1 1 7 7m1.2e-4 -7-7 7"
      />
    </svg>
  );
}
